export default __webpack_public_path__ + "static/media/pg-43.cb5a8c54.jpg";